var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
var ProgressionDialogType = /* @__PURE__ */ ((ProgressionDialogType2) => {
  ProgressionDialogType2[ProgressionDialogType2["create"] = 0] = "create";
  ProgressionDialogType2[ProgressionDialogType2["read"] = 1] = "read";
  ProgressionDialogType2[ProgressionDialogType2["iterate"] = 2] = "iterate";
  ProgressionDialogType2[ProgressionDialogType2["promoteFlight"] = 3] = "promoteFlight";
  ProgressionDialogType2[ProgressionDialogType2["bulkEditStages"] = 4] = "bulkEditStages";
  ProgressionDialogType2[ProgressionDialogType2["bulkEditConfirm"] = 5] = "bulkEditConfirm";
  ProgressionDialogType2[ProgressionDialogType2["readAndEdit"] = 6] = "readAndEdit";
  ProgressionDialogType2[ProgressionDialogType2["editConfirm"] = 7] = "editConfirm";
  return ProgressionDialogType2;
})(ProgressionDialogType || {});
var FlightType = /* @__PURE__ */ ((FlightType2) => {
  FlightType2["Treatment"] = "Treatment";
  FlightType2["CustomControl"] = "CustomControl";
  FlightType2["StandardControl"] = "StandardControl";
  FlightType2["ReserveTreatment"] = "ReserveTreatment";
  FlightType2["ReserveControl"] = "ReserveControl";
  FlightType2["Interleaving"] = "Interleaving";
  FlightType2["Combo"] = "Combo";
  return FlightType2;
})(FlightType || {});
var TreatmentVariableType = /* @__PURE__ */ ((TreatmentVariableType2) => {
  TreatmentVariableType2[TreatmentVariableType2["Boolean"] = 0] = "Boolean";
  TreatmentVariableType2[TreatmentVariableType2["Number"] = 1] = "Number";
  TreatmentVariableType2[TreatmentVariableType2["String"] = 2] = "String";
  return TreatmentVariableType2;
})(TreatmentVariableType || {});
var StudyOperations = /* @__PURE__ */ ((StudyOperations2) => {
  StudyOperations2[StudyOperations2["start"] = 0] = "start";
  StudyOperations2[StudyOperations2["stop"] = 1] = "stop";
  StudyOperations2[StudyOperations2["advance"] = 2] = "advance";
  StudyOperations2[StudyOperations2["transfer"] = 3] = "transfer";
  StudyOperations2[StudyOperations2["restart"] = 4] = "restart";
  return StudyOperations2;
})(StudyOperations || {});
var ProgressionCategory = /* @__PURE__ */ ((ProgressionCategory2) => {
  ProgressionCategory2[ProgressionCategory2["Restricted"] = 0] = "Restricted";
  ProgressionCategory2[ProgressionCategory2["FreeForm"] = 1] = "FreeForm";
  return ProgressionCategory2;
})(ProgressionCategory || {});
const _ExperimentStepStates = class _ExperimentStepStates {
  static stepNotRunning(state) {
    if (!state) {
      return false;
    }
    return !compareIgnoreCase(state, _ExperimentStepStates.RUNNING) && !compareIgnoreCase(state, _ExperimentStepStates.RUNNING_WITH_ISSUES) && !compareIgnoreCase(state, _ExperimentStepStates.START_REQUESTED);
  }
  static isStoppingOrCompleted(state) {
    if (!state) {
      return false;
    }
    return state.toLowerCase() === _ExperimentStepStates.STOP_REQUESTED.toLowerCase() || state.toLowerCase() === _ExperimentStepStates.COMPLETED.toLowerCase();
  }
  static canStart(state) {
    return !!state && state.toLowerCase() === _ExperimentStepStates.NEW.toLowerCase();
  }
  static canStop(state) {
    return !!state && (state.toLowerCase() === _ExperimentStepStates.RUNNING.toLowerCase() || state.toLowerCase() === _ExperimentStepStates.RUNNING_WITH_ISSUES.toLowerCase() || state.toLowerCase() === _ExperimentStepStates.START_REQUESTED.toLowerCase());
  }
  static isNew(state) {
    return !!state && state.toLowerCase() === _ExperimentStepStates.NEW.toLowerCase();
  }
  static isCompleted(state) {
    return !!state && state.toLowerCase() === _ExperimentStepStates.COMPLETED.toLowerCase();
  }
  static isStartingOrRunning(state) {
    return !!state && (state.toLowerCase() === _ExperimentStepStates.START_REQUESTED.toLowerCase() || state.toLowerCase() === _ExperimentStepStates.RUNNING.toLowerCase());
  }
};
__publicField(_ExperimentStepStates, "NEW", "new");
__publicField(_ExperimentStepStates, "START_REQUESTED", "startrequested");
__publicField(_ExperimentStepStates, "RUNNING", "running");
__publicField(_ExperimentStepStates, "RUNNING_WITH_ISSUES", "runningwithissues");
__publicField(_ExperimentStepStates, "STOP_REQUESTED", "stoprequested");
__publicField(_ExperimentStepStates, "COMPLETED", "completed");
__publicField(_ExperimentStepStates, "MIGRATING", "migrating");
__publicField(_ExperimentStepStates, "MIGRATIONSUCCEEDED", "migrationsucceeded");
__publicField(_ExperimentStepStates, "MIGRATIONFAILED", "migrationfailed");
let ExperimentStepStates = _ExperimentStepStates;
const _ExperimentStates = class _ExperimentStates {
  static canStart(state) {
    return state.toLowerCase() === _ExperimentStates.NEW;
  }
  static canStop(state) {
    return state.toLowerCase() === _ExperimentStates.STARTING || state.toLowerCase() === _ExperimentStates.RUNNING;
  }
  static canRestart(state) {
    return state.toLowerCase() === _ExperimentStates.COMPLETED || state.toLowerCase() === _ExperimentStates.STOPPING;
  }
  static canAdvance(stages) {
    return stages.filter((s) => s.state.toLowerCase() === _ExperimentStates.NEW).length > 0 && stages.filter((s) => s.state.toLowerCase() !== _ExperimentStates.NEW).length > 0;
  }
};
__publicField(_ExperimentStates, "RUNNING", "running");
__publicField(_ExperimentStates, "STARTING", "starting");
__publicField(_ExperimentStates, "STOPPING", "stopping");
__publicField(_ExperimentStates, "NEW", "new");
__publicField(_ExperimentStates, "COMPLETED", "completed");
__publicField(_ExperimentStates, "UNKNOWN", "unknown");
__publicField(_ExperimentStates, "MIGRATING", "migrating");
__publicField(_ExperimentStates, "MIGRATIONSUCCEEDED", "migrationsucceeded");
__publicField(_ExperimentStates, "MIGRATIONFAILED", "migrationfailed");
let ExperimentStates = _ExperimentStates;
var ExperimentStepType = /* @__PURE__ */ ((ExperimentStepType2) => {
  ExperimentStepType2["AA"] = "AA";
  ExperimentStepType2["AB"] = "AB";
  ExperimentStepType2["DataCollection"] = "DataCollection";
  ExperimentStepType2["SeedFinder"] = "SeedFinder";
  ExperimentStepType2["Interleaving"] = "Interleaving";
  ExperimentStepType2["InterleavingOnly"] = "InterleavingOnly";
  ExperimentStepType2["ExternalAB"] = "ExternalAB";
  ExperimentStepType2["Unknown"] = "Unknown";
  return ExperimentStepType2;
})(ExperimentStepType || {});
var StageTrafficSource = /* @__PURE__ */ ((StageTrafficSource2) => {
  StageTrafficSource2[StageTrafficSource2["templateDefined"] = 0] = "templateDefined";
  StageTrafficSource2[StageTrafficSource2["userSpecified"] = 1] = "userSpecified";
  return StageTrafficSource2;
})(StageTrafficSource || {});
var OverrideType = /* @__PURE__ */ ((OverrideType2) => {
  OverrideType2["ForcedInclude"] = "ForcedInclude";
  OverrideType2["ForcedExclude"] = "ForcedExclude";
  OverrideType2["EmergencyForcedExclude"] = "EmergencyForcedExclude";
  return OverrideType2;
})(OverrideType || {});
var ProgressionType = /* @__PURE__ */ ((ProgressionType2) => {
  ProgressionType2[ProgressionType2["SingleTreatmentProgression"] = 1] = "SingleTreatmentProgression";
  ProgressionType2[ProgressionType2["ABnProgression"] = 2] = "ABnProgression";
  ProgressionType2[ProgressionType2["OverrideSetProgression"] = 3] = "OverrideSetProgression";
  return ProgressionType2;
})(ProgressionType || {});
var ProgressionSettingsType = /* @__PURE__ */ ((ProgressionSettingsType2) => {
  ProgressionSettingsType2[ProgressionSettingsType2["SingleTreatmentProgressionSettings"] = 1] = "SingleTreatmentProgressionSettings";
  ProgressionSettingsType2[ProgressionSettingsType2["ABnProgressionSettings"] = 2] = "ABnProgressionSettings";
  ProgressionSettingsType2[ProgressionSettingsType2["OverrideSetProgressionSettings"] = 3] = "OverrideSetProgressionSettings";
  ProgressionSettingsType2[ProgressionSettingsType2["ABnCustomizedSettings"] = 4] = "ABnCustomizedSettings";
  ProgressionSettingsType2[ProgressionSettingsType2["SingleTreatmentCustomizedSettings"] = 5] = "SingleTreatmentCustomizedSettings";
  return ProgressionSettingsType2;
})(ProgressionSettingsType || {});
var TrafficDistributionType = /* @__PURE__ */ ((TrafficDistributionType2) => {
  TrafficDistributionType2[TrafficDistributionType2["SingleTreatmentMirrorControl"] = 1] = "SingleTreatmentMirrorControl";
  TrafficDistributionType2[TrafficDistributionType2["EvenDistributionAllFlights"] = 2] = "EvenDistributionAllFlights";
  return TrafficDistributionType2;
})(TrafficDistributionType || {});
var ProgressionUserInterfaceType = /* @__PURE__ */ ((ProgressionUserInterfaceType2) => {
  ProgressionUserInterfaceType2[ProgressionUserInterfaceType2["HorizontalCards"] = 1] = "HorizontalCards";
  ProgressionUserInterfaceType2[ProgressionUserInterfaceType2["HorizontalCardsWithFlightSet"] = 2] = "HorizontalCardsWithFlightSet";
  ProgressionUserInterfaceType2[ProgressionUserInterfaceType2["VerticalRows"] = 3] = "VerticalRows";
  ProgressionUserInterfaceType2[ProgressionUserInterfaceType2["SwimLanes"] = 4] = "SwimLanes";
  return ProgressionUserInterfaceType2;
})(ProgressionUserInterfaceType || {});
var ProgressionOperationType = /* @__PURE__ */ ((ProgressionOperationType2) => {
  ProgressionOperationType2[ProgressionOperationType2["Start"] = 1] = "Start";
  ProgressionOperationType2[ProgressionOperationType2["Advance"] = 2] = "Advance";
  ProgressionOperationType2[ProgressionOperationType2["Stop"] = 3] = "Stop";
  ProgressionOperationType2[ProgressionOperationType2["Restart"] = 4] = "Restart";
  ProgressionOperationType2[ProgressionOperationType2["Transfer"] = 5] = "Transfer";
  return ProgressionOperationType2;
})(ProgressionOperationType || {});
var OverrideOperationType = /* @__PURE__ */ ((OverrideOperationType2) => {
  OverrideOperationType2[OverrideOperationType2["Start"] = 1] = "Start";
  OverrideOperationType2[OverrideOperationType2["Advance"] = 2] = "Advance";
  OverrideOperationType2[OverrideOperationType2["Stop"] = 3] = "Stop";
  return OverrideOperationType2;
})(OverrideOperationType || {});
var IsolationGroupCategoryOption = /* @__PURE__ */ ((IsolationGroupCategoryOption2) => {
  IsolationGroupCategoryOption2["autoGeneratedIsolationGroup"] = "autoGeneratedIsolationGroup";
  IsolationGroupCategoryOption2["sharedIsolationGroup"] = "sharedIsolationGroup";
  return IsolationGroupCategoryOption2;
})(IsolationGroupCategoryOption || {});
export {
  ExperimentStates,
  ExperimentStepStates,
  ExperimentStepType,
  FlightType,
  IsolationGroupCategoryOption,
  OverrideOperationType,
  OverrideType,
  ProgressionCategory,
  ProgressionDialogType,
  ProgressionOperationType,
  ProgressionSettingsType,
  ProgressionType,
  ProgressionUserInterfaceType,
  StageTrafficSource,
  StudyOperations,
  TrafficDistributionType,
  TreatmentVariableType
};
//# sourceMappingURL=FeatureDataModel.js.map
